var Review, templates;

templates = require('../../client-templates');

module.exports = Review = (function() {
  function Review(arg) {
    this.data = arg.data, this.uuid = arg.uuid, this.$el = arg.$el;
  }

  Review.prototype.prepareData = function() {
    var bhc, i, position, rating, ref, starType, stars;
    if (!(((ref = this.data) != null ? ref.averageRating : void 0) && this.data.ratingCount)) {
      return;
    }
    rating = Math.round(this.data.averageRating * 10) / 10;
    bhc = {
      rating: "review-rating:" + this.uuid + "_" + rating,
      ratingCount: "rating-count:" + this.uuid + "_" + this.data.ratingCount
    };
    stars = [];
    for (position = i = 1; i <= 5; position = ++i) {
      starType = (function() {
        switch (false) {
          case !(rating > 3 / 4):
            return 'full-star';
          case !(rating > 1 / 4):
            return 'half-star';
          default:
            return 'empty-star';
        }
      })();
      stars.push("<span class='" + starType + "'></span>");
      rating--;
    }
    return {
      productRating: {
        bhc: bhc,
        count: I18n.toNumber(this.data.ratingCount),
        stars: stars
      }
    };
  };

  Review.prototype.render = function() {
    return this.$el.find('.deal-title').after(templates.product_reviews.render(this.prepareData()));
  };

  return Review;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvbXRydW9uZy9uYXBpc3RyYW5vL2J1aWxkLzE0Nzg4MTkxMzcwNzgtMzgwMDkvc3RhZ2luZy1wZXJmLTIwMTYuMTEuMDlfMjMuMzIvZ29vZHMtaG9tZXBhZ2UvbW9kdWxlcy9wcm9kdWN0X3Jldmlld3MvZnJvbnRlbmQvcmV2aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL210cnVvbmcvbmFwaXN0cmFuby9idWlsZC8xNDc4ODE5MTM3MDc4LTM4MDA5L3N0YWdpbmctcGVyZi0yMDE2LjExLjA5XzIzLjMyL2dvb2RzLWhvbWVwYWdlL21vZHVsZXMvcHJvZHVjdF9yZXZpZXdzL2Zyb250ZW5kL3Jldmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxTQUFBLEdBQVksT0FBQSxDQUFRLHdCQUFSOztBQUVaLE1BQU0sQ0FBQyxPQUFQLEdBQXVCO0VBQ1IsZ0JBQUMsR0FBRDtJQUFFLElBQUMsQ0FBQSxXQUFBLE1BQU0sSUFBQyxDQUFBLFdBQUEsTUFBTSxJQUFDLENBQUEsVUFBQTtFQUFqQjs7bUJBRWIsV0FBQSxHQUFhLFNBQUE7QUFDWCxRQUFBO0lBQUEsSUFBQSxDQUFBLGlDQUFtQixDQUFFLHVCQUFQLElBQXlCLElBQUMsQ0FBQSxJQUFJLENBQUMsV0FBN0MsQ0FBQTtBQUFBLGFBQUE7O0lBRUEsTUFBQSxHQUFTLElBQUksQ0FBQyxLQUFMLENBQVcsSUFBQyxDQUFBLElBQUksQ0FBQyxhQUFOLEdBQXNCLEVBQWpDLENBQUEsR0FBdUM7SUFDaEQsR0FBQSxHQUNFO01BQUEsTUFBQSxFQUFRLGdCQUFBLEdBQWlCLElBQUMsQ0FBQSxJQUFsQixHQUF1QixHQUF2QixHQUEwQixNQUFsQztNQUNBLFdBQUEsRUFBYSxlQUFBLEdBQWdCLElBQUMsQ0FBQSxJQUFqQixHQUFzQixHQUF0QixHQUF5QixJQUFDLENBQUEsSUFBSSxDQUFDLFdBRDVDOztJQUdGLEtBQUEsR0FBUTtBQUNSLFNBQWdCLHdDQUFoQjtNQUNFLFFBQUE7QUFBVyxnQkFBQSxLQUFBO0FBQUEsaUJBQ0osTUFBQSxHQUFTLENBQUEsR0FBSSxFQURUO21CQUVQO0FBRk8saUJBR0osTUFBQSxHQUFTLENBQUEsR0FBSSxFQUhUO21CQUlQO0FBSk87bUJBTVA7QUFOTzs7TUFPWCxLQUFLLENBQUMsSUFBTixDQUFXLGVBQUEsR0FBZ0IsUUFBaEIsR0FBeUIsV0FBcEM7TUFDQSxNQUFBO0FBVEY7V0FXQTtNQUFBLGFBQUEsRUFDRTtRQUFBLEdBQUEsRUFBSyxHQUFMO1FBQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxRQUFMLENBQWMsSUFBQyxDQUFBLElBQUksQ0FBQyxXQUFwQixDQURQO1FBRUEsS0FBQSxFQUFPLEtBRlA7T0FERjs7RUFwQlc7O21CQXlCYixNQUFBLEdBQVEsU0FBQTtXQUNOLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLGFBQVYsQ0FBd0IsQ0FBQyxLQUF6QixDQUErQixTQUFTLENBQUMsZUFBZSxDQUFDLE1BQTFCLENBQWlDLElBQUMsQ0FBQSxXQUFELENBQUEsQ0FBakMsQ0FBL0I7RUFETSJ9
